import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card, withStyles } from 'vopay';
import { Title, Button } from 'UI';
import { useAccountTransfer } from './useAccountTransfer';
import styles from './AccountTransferPage.module.scss';

const cn = withStyles(styles);

const AccountTransferPage: FC = () => {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.AccountTransfer' });
  const { ctx, renderFormElements, isUnderReview, setIsUnderReview } = useAccountTransfer();

  return (
    <Box jc="center">
      <Box flx="col" jc="center" maxwidth="1121px" boxWidth="100%" p="md" gapSize="32px">
        <Title>{t('title', { defaultValue: 'Account Transfer' })}</Title>
        <form onSubmit={ctx.handleSubmit}>
          <Card>
            <div className={cn('grid')}>{renderFormElements()}</div>
          </Card>

          <Box pt="md" jc="fe">
            {!isUnderReview && (
              <Button colorScheme="primary" onClick={() => setIsUnderReview(true)} disabled={!ctx.isValid}>
                {tGlobal('Buttons.review', { defaultValue: 'Review' })}
              </Button>
            )}
            {isUnderReview && (
              <Box gapSize="10px">
                <Button type="button" onClick={() => setIsUnderReview(false)}>
                  {tGlobal('Buttons.edit', { defaultValue: 'Edit' })}
                </Button>
                <Button type="submit" disabled={!ctx.isValid} colorScheme="primary">
                  {tGlobal('Buttons.transfer', { defaultValue: 'Transfer' })}
                </Button>
              </Box>
            )}
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default AccountTransferPage;
